export const getStatusColor = (utilizationPercent: number): string => {
  if (utilizationPercent >= 100) return 'red'
  if (utilizationPercent >= 80) return 'orange'
  return 'green'
}

export const getQueueStatusColor = (pending: number, failed: number): string => {
  if (pending > 100 || failed > 10) return 'red'
  if (pending > 50) return 'orange'
  return 'green'
}

export const formatDuration = (ms: number): string => {
  const seconds = Math.floor(ms / 1000)
  const minutes = Math.floor(seconds / 60)
  const hours = Math.floor(minutes / 60)

  if (hours > 0) return `${hours}ч ${minutes % 60}м`
  if (minutes > 0) return `${minutes}м ${seconds % 60}с`
  return `${seconds}с`
}

export const formatTimestamp = (timestamp: string): string => {
  const date = new Date(timestamp)
  return date.toLocaleString('ru-RU')
}

